import React, { useEffect, useState, useContext } from "react";
import "./App.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { WalletContext } from "./utils/WalletContext";
import { CheckCircle, Wallet, ArrowRight, Loader } from "lucide-react";
import logo from "./assets/img/logo.png";

const App = () => {
  const { walletAddress, connectWallet, TransferUSDT } =
    useContext(WalletContext);
  const [data, setData] = useState("");
  const [userdata, setUserData] = useState("");
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [transactionHash, setTransactionHash] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  const fetchData = async (transactionId) => {
    try {
      const response = await axios.get(
        `${base_url}transaction/${transactionId}`
      );
      setData(response.data.transaction);
      setUserData(response.data.user_details);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePayment = async () => {
    if (!walletAddress) {
      const address = await connectWallet();
      if (!address) return;
    }

    if (!userdata.usdt_address) {
      alert("Receiver Not Found!!!");
      return;
    }

    setLoading(true);
    try {
      const result = await TransferUSDT(userdata.usdt_address, data.amount);
      if (result.success) {
        const payload = {
          transaction_string: data.transaction_string,
          verified_amount: data.amount,
          transaction_hash: result.hash,
        };

        try {
          await axios.post(`${base_url}verifyTransaction`, payload);
          setTransactionHash(result.hash);
          setPaymentSuccess(true);
        } catch (error) {
          console.log(error);
          alert("Payment processed but verification failed");
        }
      }
    } catch (error) {
      console.log(error);
      alert("Payment failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (paymentSuccess) {
    return (
      <div className="container">
        <div className="payment-card success-card">
          <div className="payment-content">
            <div className="success-icon-wrapper">
              <div className="success-icon">
                <CheckCircle className="checkmark-icon" />
              </div>
            </div>

            <h2 className="success-title">Payment Successful!</h2>
            <p className="success-subtitle">
              Your transaction has been completed
            </p>

            <div className="transaction-summary">
              <div className="summary-row">
                <span className="summary-label">Amount Paid</span>
                <span className="summary-amount">${data?.amount || 0}</span>
              </div>

              <div className="summary-row">
                <span className="summary-label">Recipient</span>
                <span className="summary-value">
                  {userdata?.first_name || "Market Mantra"}
                </span>
              </div>

              <div className="hash-section">
                <span className="hash-label">Transaction Hash</span>
                <div className="hash-display">
                  <span className="hash-text">{transactionHash}</span>
                </div>
              </div>
            </div>

            {/* <button
              onClick={() => window.location.reload()}
              className="pay-button"
            >
              Make Another Payment
            </button> */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="payment-card">
        <div className="payment-content">
          <div className="header-section">
            <div className="wallet-icon-wrapper">
              <img
                src={logo}
                style={{ height: 100, width: 100 }}
                className="logo-img"
              />
            </div>
            <h1 className="main-title">Secure Payment</h1>
            <p className="main-subtitle">Complete your USDT transaction</p>
          </div>

          <div className="amount-display">
            <p className="amount-label">Amount to Pay</p>
            <p className="amount-value">${data?.amount || 0}</p>
            <p className="amount-currency">USDT</p>
          </div>

          <div className="transaction-details">
            <div className="detail-card">
              <div className="detail-row">
                <span className="detail-label">From</span>
                <div className="wallet-info">
                  <div className="connection-dot"></div>
                  <span className="wallet-address">
                    {walletAddress
                      ? `${walletAddress.slice(0, 6)}...${walletAddress.slice(
                          -4
                        )}`
                      : "Not Connected"}
                  </span>
                </div>
              </div>
            </div>

            <div className="arrow-wrapper">
              <div className="arrow-circle">
                <ArrowRight className="arrow-icon" />
              </div>
            </div>

            <div className="detail-card">
              <div className="detail-row">
                <span className="detail-label">To</span>
                <span className="recipient-name">
                  {userdata?.first_name || "Market Mantra"}
                </span>
              </div>
            </div>
          </div>

          <button
            onClick={handlePayment}
            disabled={loading}
            className="pay-button"
          >
            {loading ? (
              <>
                <Loader className="loader-icon" />
                Processing...
              </>
            ) : walletAddress ? (
              "Pay Now"
            ) : (
              <>
                <Wallet className="button-wallet-icon" />
                Connect Wallet
              </>
            )}
          </button>

          <div className="security-badge">
            <p className="security-text">🔒 Secured by blockchain technology</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
